const prosthetics = {
  hero: {
    titlePrefix: "Fortschrittliche Lösungen für",
    titleAccent: "Zahnprothetik",
    titleSuffix: "",
    description:
      "Stellen Sie Ihr Lächeln und Ihre Zahnfunktion wieder her mit unseren maßgefertigten, hochwertigen Prothetiklösungen, die so konzipiert sind, dass sie wie natürliche Zähne aussehen, sich so anfühlen und funktionieren.",
    ctas: {
      primary: "Beratungstermin vereinbaren",
      secondary: "Mehr über den Ablauf erfahren",
    },
    imageAlt: "Zahnersatz einschließlich Prothesen und Brücken",
    callout: {
      title: "Natürlich aussehende Ergebnisse",
      body:
        "Unsere prothetischen Lösungen sind so gefertigt, dass sie perfekt zu Ihren natürlichen Zähnen passen.",
    },
  },
  benefits: {
    heading: "Vorteile von Zahnprothetik",
    intro:
      "Entdecken Sie, warum Patienten unsere prothetischen Lösungen zur Wiederherstellung ihres Lächelns wählen",
    items: [
      {
        title: "Natürliche Ästhetik",
        description:
          "Unsere Prothetik ist so konzipiert, dass sie von natürlichen Zähnen nicht zu unterscheiden ist, und gibt Ihnen Ihr selbstbewusstes Lächeln zurück.",
      },
      {
        title: "Verbesserte Funktion",
        description:
          "Genießen Sie wieder natürliches Essen, Sprechen und Lächeln mit richtig sitzenden und funktionalen prothetischen Zähnen.",
      },
      {
        title: "Bessere Mundgesundheit",
        description:
          "Zahnersatz hilft, das Verschieben der verbleibenden Zähne zu verhindern und die Gesichtsstruktur sowie die Knochenintegrität zu erhalten.",
      },
      {
        title: "Langlebige Ergebnisse",
        description:
          "Unsere hochwertigen Materialien und fachmännische Handwerkskunst stellen sicher, dass Ihre Prothetik jahrelang hält.",
      },
      {
        title: "Präventiver Schutz",
        description:
          "Zahnersatz hilft, Ihre verbleibenden natürlichen Zähne vor übermäßiger Abnutzung und Belastung zu schützen.",
      },
      {
        title: "Maßgeschneiderte Lösungen",
        description:
          "Jede Prothese wird maßgefertigt nach Ihren spezifischen Bedürfnissen, um eine perfekte Passform und maximalen Komfort zu gewährleisten.",
      },
    ],
    bottomLinePrefix: "Bereit, Ihr Lächeln wiederherzustellen?",
    bottomLineCta: "Vereinbaren Sie noch heute einen Beratungstermin für Prothetik.",
  },
  process: {
    heading: "Unser Prozess für prothetische Behandlungen",
    intro:
      "Ein schrittweiser Ansatz zur Wiederherstellung Ihres Lächelns mit Präzision und Sorgfalt",
    steps: [
      {
        title: "Erstberatung",
        description:
          "Unser Spezialist wird Ihren Zahnzustand beurteilen, Ihre Bedürfnisse besprechen und die verfügbaren prothetischen Optionen erläutern.",
      },
      {
        title: "Umfassende Untersuchung",
        description:
          "Wir führen eine gründliche Beurteilung durch, einschließlich digitaler Scans und Röntgenaufnahmen, um einen präzisen Behandlungsplan zu erstellen.",
      },
      {
        title: "Behandlungsplanung",
        description:
          "Basierend auf Ihrer Untersuchung entwickeln wir eine maßgeschneiderte prothetische Lösung, die auf Ihre spezifischen Bedürfnisse zugeschnitten ist.",
      },
      {
        title: "Abdrücke & Design",
        description:
          "Wir nehmen detaillierte Abdrücke, um sicherzustellen, dass Ihre Prothetik perfekt passt und Ihren natürlichen Zähnen entspricht.",
      },
      {
        title: "Fertigung & Anpassung",
        description:
          "Ihr maßgefertigter Zahnersatz wird in unserem Labor hergestellt und anschließend präzise für Komfort und Funktion angepasst.",
      },
      {
        title: "Nachsorge & Wartung",
        description:
          "Wir geben Ihnen Pflegeanweisungen für den Alltag und vereinbaren regelmäßige Kontrolluntersuchungen, um langlebige Ergebnisse zu gewährleisten.",
      },
    ],
  },
  faq: {
    heading: "Häufig gestellte Fragen",
    intro: "Erhalten Sie Antworten auf häufige Fragen zu Zahnprothetik",
    items: [
      {
        question: "Welche Arten von Zahnersatz bieten Sie an?",
        answer:
          "Wir bieten ein umfassendes Spektrum an Zahnersatz an, einschließlich festsitzender Prothetik (Kronen, Brücken und implantatgetragene Restaurationen) und herausnehmbarer Prothetik (Voll- und Teilprothesen). Unsere Spezialisten helfen Ihnen zu bestimmen, welche Option am besten für Ihre spezifischen Bedürfnisse und Vorlieben geeignet ist.",
      },
      {
        question: "Wie lange hält Zahnersatz?",
        answer:
          "Die Lebensdauer von Zahnersatz variiert je nach Art und verwendeten Materialien. Bei richtiger Pflege und Wartung können Kronen und Brücken 10-15 Jahre halten, während hochwertige Prothesen typischerweise 5-7 Jahre halten. Implantatgetragener Zahnersatz kann bei hervorragender Mundhygiene 15+ Jahre oder sogar ein Leben lang halten.",
      },
      {
        question: "Wird mein Zahnersatz natürlich aussehen?",
        answer:
          "Absolut! Wir sind stolz darauf, Zahnersatz zu schaffen, der von natürlichen Zähnen kaum zu unterscheiden ist. Unsere fortschrittliche digitale Bildgebungstechnologie und hochwertigen Materialien ermöglichen es uns, Farbe, Form und Transparenz Ihrer natürlichen Zähne anzupassen, um ein nahtloses und natürliches Aussehen zu gewährleisten.",
      },
      {
        question: "Ist es schwierig, sich an das Tragen von Zahnersatz zu gewöhnen?",
        answer:
          "Es gibt typischerweise eine Eingewöhnungszeit, wenn Sie zum ersten Mal Zahnersatz erhalten. Die meisten Patienten passen sich innerhalb weniger Wochen an, während sie sich daran gewöhnen, mit ihren neuen Zähnen zu sprechen und zu essen. Unser Team bietet umfassende Anleitung und Unterstützung während dieser Übergangszeit, um maximalen Komfort zu gewährleisten.",
      },
      {
        question: "Wie pflege ich meinen Zahnersatz?",
        answer:
          "Die Pflegehinweise variieren je nach Art der Prothetik. Im Allgemeinen erfordert festsitzender Zahnersatz regelmäßiges Bürsten, Zahnseide und professionelle Reinigungen. Herausnehmbarer Zahnersatz sollte täglich mit speziellen Lösungen und Bürsten gereinigt und bei Nichtgebrauch ordnungsgemäß aufbewahrt werden. Wir stellen detaillierte Pflegehinweise zur Verfügung, die auf Ihre spezifische Prothetik zugeschnitten sind.",
      },
      {
        question: "Wird Zahnersatz von der Versicherung übernommen?",
        answer:
          "Viele Zahnzusatzversicherungen bieten eine teilweise Abdeckung für prothetische Behandlungen, die typischerweise als größere restaurative Eingriffe kategorisiert werden. Die Deckungssummen variieren je nach Anbieter und Tarif. Unser Verwaltungsteam kann helfen, Ihre Versicherungsleistungen zu überprüfen und Finanzierungsoptionen zu besprechen, um Ihre Behandlung erschwinglich zu machen.",
      },
    ],
    bottomLine: "Haben Sie noch Fragen zu unseren Prothesenlösungen?",
    cta: "Kontaktieren Sie uns",
  },
};

export default prosthetics;

